import { HiCheckCircle } from "react-icons/hi2";

export const RoundedCheckIcon = ({ width, height, color, ...props }) => (
  <HiCheckCircle
    size={width || height || 20}
    color={color || "#fff"}
    {...props}
  />
);
